import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import Footer from "./component/Footer";
import AccountSidebar from "./component/AccountSidebar";
import userProfile from "./services/userProfile";
import api from './api';

const MyProfile = () => {
    const navigate = useNavigate();

    const [isVisible, setIsVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");

    const [mobileView, setMobileView] = useState("menu");

    const [profile, setProfile] = useState({ name: '', email: '', gender: '', avatar: '' });
    const [formData, setFormData] = useState({ name: '', email: '', gender: '', phone: '' });
    const [avatarFile, setAvatarFile] = useState(null);
    const [avatarPreview, setAvatarPreview] = useState('');

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'auto' });
        const toggleVisibility = () => setIsVisible(window.pageYOffset > 300);
        window.addEventListener('scroll', toggleVisibility);
        return () => window.removeEventListener('scroll', toggleVisibility);
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleAvatarChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setAvatarFile(file);
            setAvatarPreview(URL.createObjectURL(file));
        }
    };
     useEffect(() => {
           if (sessionStorage.getItem("mob_nav_direct") === "true") {
               sessionStorage.removeItem("mob_nav_direct");
               setMobileView("form");
           }
       }, []);
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true); setError(""); setSuccess("");

        // FIX 2: frontend validation before API call
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
        const cleanEmail = formData.email?.toLowerCase().trim();

        if (!formData.name?.trim()) {
            setError("Name is required");
            setLoading(false);
            return;
        }
        if (!emailRegex.test(cleanEmail)) {
            setError("Please enter a valid email address");
            setLoading(false);
            return;
        }

        try {
            const storedData = localStorage.getItem("userData");
            const token = storedData ? JSON.parse(storedData).token : null;
            if (!token) { setError("Please login again."); setLoading(false); return; }

            const payload = { 
                name: formData.name?.trim(), 
                email: cleanEmail, 
                gender: formData.gender 
            };

            if (avatarFile) {
                const toBase64 = (file) => new Promise((res, rej) => {
                    const r = new FileReader();
                    r.readAsDataURL(file);
                    r.onload = () => res(r.result);
                    r.onerror = rej;
                });
                payload.avatar = await toBase64(avatarFile);
            }

            const response = await api.post('user/update-profile', payload, {
                headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
            });

            if (response.data.message === "Profile updated successfully") {
                setSuccess("Profile updated successfully!");
                setTimeout(() => setSuccess(""), 3000);
                setAvatarFile(null);
            } else {
                setError(response.data.message || "Failed to update profile");
            }
        } catch (error) {
            // FIX 2: hide raw "Internal Server Error"
            const status = error.response?.status;
            const msg = error.response?.data?.message;
            if (status >= 500) {
                setError("Something went wrong. Please check your details and try again.");
            } else {
                setError(msg || "An error occurred");
            }
        } finally {
            setLoading(false);
        }
    };

    const getuserProfileData = async () => {
        try {
            const res = await userProfile();
            const userData = res.data.user;
            setProfile(userData);
            setFormData({
                name: userData.name || '',
                email: userData.email || '',
                gender: userData.gender || '',
                phone: userData.phone || ''
            });
        } catch (error) {
            setError("Failed to load profile data");
        }
    };

    useEffect(() => { getuserProfileData(); }, []);

    // FIX 1: plain function, not component. No remount -> input keep focus.
    const renderProfileForm = (inputId = "avatar-upload") => (
        <div className="profile-card">
            <h3>User Information</h3>
            {success && <div className="alert alert-success">{success}</div>}
            {error && <div className="alert alert-error">{error}</div>}

            <form className="profile-form" onSubmit={handleSubmit} noValidate>
                <div className="avatar-section">
                    {avatarPreview || profile.avatar ? (
                        <img src={avatarPreview || profile.avatar} alt="Avatar" className="avatar-img" />
                    ) : (
                        <div className="avatar-placeholder">
                            {formData.name ? formData.name.charAt(0).toUpperCase() : 'U'}
                        </div>
                    )}
                    <div>
                        <label htmlFor={inputId} className="avatar-upload-label">Change Photo</label>
                        <input id={inputId} type="file" accept="image/*" onChange={handleAvatarChange} style={{ display: 'none' }} />
                        <p style={{ fontSize: '12px', color: '#888', marginTop: '6px' }}>JPG, PNG up to 5MB</p>
                    </div>
                </div>

                <input className="form-input" type="text" name="name" placeholder="Full Name" value={formData.name} onChange={handleChange} required />
                <input className="form-input" type="email" name="email" placeholder="Email Address" value={formData.email} onChange={handleChange} required />
                <input className="form-input" type="text" name="phone" placeholder="Mobile Number" value={formData.phone} readOnly />
                <p style={{ fontSize: '12px', color: '#888', marginTop: '-10px' }}>📱 Mobile number cannot be changed</p>

                <select className="form-input" name="gender" value={formData.gender} onChange={handleChange}>
                    <option value="">Select Gender</option>
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                    <option value="other">Other</option>
                </select>

                <button type="submit" className="submit-btn" disabled={loading}>
                    {loading ? 'Updating...' : 'Save Changes'}
                </button>
            </form>
        </div>
    );

    return (
        <>
            <style>{`
                .dashboard-wrapper { display: flex; min-height: 80vh; padding: 20px; gap: 20px; }
                .dashboard-content { flex: 1; min-width: 0; padding: 10px; }

                /* Mobile Sidebar */
                .acct-mobile-only-wrapper { display: none; }

                /* Mobile Content Panel */
                .wl-mob-header {
                    display: flex; align-items: center; justify-content: space-between;
                    padding: 13px 16px; background: #fff; border-bottom: 1px solid #f0f0f0;
                    position: sticky; top: 0; z-index: 10;
                }
                .wl-mob-back-btn {
                    width: 36px; height: 36px; border: none; background: none;
                    font-size: 28px; color: #333; cursor: pointer;
                }
                .wl-mob-title { font-size: 16px; font-weight: 700; color: #111; margin: 0; }
                .wl-mob-body { padding: 16px; background: #fff; min-height: auto; }

                /* Profile Card */
                .profile-card {
                    background: #fff; border-radius: 12px; box-shadow: 0 2px 12px rgba(0,0,0,0.08); 
                    padding: 32px;
                }
                .profile-card h3 { font-size: 20px; font-weight: 600; color: #333; text-align: center; margin-bottom: 24px; }
                .alert { padding: 12px 16px; border-radius: 6px; margin-bottom: 16px; font-size: 14px; text-align: center; }
                .alert-success { background: #d4edda; color: #155724; }
                .alert-error { background: #f8d7da; color: #721c24; }
                .profile-form { display: flex; flex-direction: column; gap: 16px; }
                .form-input {
                    padding: 12px 16px; border-radius: 8px; border: 1px solid #ddd;
                    font-size: 15px; width: 100%; box-sizing: border-box;
                }
                .form-input:focus { border-color: #c9a227; box-shadow: 0 0 0 3px rgba(201,162,39,0.12); }

                .avatar-section { display: flex; align-items: center; gap: 16px; flex-wrap: wrap; }
                .avatar-img { width: 72px; height: 72px; border-radius: 50%; object-fit: cover; border: 2px solid #c9a227; }
                .avatar-placeholder {
                    width: 72px; height: 72px; border-radius: 50%; background: #fff8e7;
                    display: flex; align-items: center; justify-content: center;
                    font-size: 28px; font-weight: 600; color: #c9a227; border: 2px solid #c9a227;
                }
                .avatar-upload-label {
                    font-size: 13px; color: #c9a227; cursor: pointer;
                    border: 1px dashed #c9a227; padding: 8px 14px; border-radius: 6px;
                }
                .submit-btn {
                    padding: 13px 20px; background: #c9a227; color: #fff;
                    border: none; border-radius: 8px; font-size: 15px; font-weight: 500;
                    cursor: pointer; margin-top: 6px;
                }

                /* ==================== VISIBILITY FIX ==================== */
                @media (max-width: 768px) {
                    .acct-mobile-only-wrapper { display: block; }
                    .dashboard-wrapper { display: none !important; }
                    .profile-card { 
                        border-radius: 0; 
                        box-shadow: none; 
                        padding: 20px 16px; 
                        min-height: auto; 
                    }
                }

                @media (min-width: 769px) {
                    .wl-mob-content-panel { display: none !important; }
                    .dashboard-wrapper { display: flex !important; }
                }
            `}</style>

            <main className="main__content_wrapper">

                {/* MOBILE SIDEBAR */}
                <div className="acct-mobile-only-wrapper">
                    <AccountSidebar
                        mobileView={mobileView}
                        setMobileView={setMobileView}
                        activeMobilePath="/my-profile"
                        contentViewName="form"
                    />
                </div>

                {/* MOBILE CONTENT */}
                <div 
                    className="wl-mob-content-panel"
                    style={{ display: mobileView === "form" ? "block" : "none" }}
                >
                    <div className="wl-mob-header">
                        <button className="wl-mob-back-btn" onClick={() => setMobileView("menu")}>‹</button>
                        <h2 className="wl-mob-title">My Profile</h2>
                        <div style={{ width: 36 }} />
                    </div>
                    <div className="wl-mob-body">
                        {renderProfileForm("avatar-mob")}
                    </div>
                </div>

                {/* DESKTOP LAYOUT */}
                <div className="container-fluid">
                    <div className="dashboard-wrapper">
                        <AccountSidebar
                            mobileView={mobileView}
                            setMobileView={setMobileView}
                            activeMobilePath="/my-profile"
                            contentViewName="form"
                        />
                        <div className="dashboard-content">
                            {renderProfileForm("avatar-desktop")}
                        </div>
                    </div>
                </div>

            </main>

            <Footer />

            <button 
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                style={{
                    position: "fixed", bottom: "30px", right: "30px",
                    width: "46px", height: "46px", borderRadius: "50%",
                    backgroundColor: "#ceb256", color: "#fff", border: "none",
                    zIndex: 1000, cursor: "pointer",
                    display: isVisible ? "flex" : "none",
                    alignItems: "center", justifyContent: "center",
                    boxShadow: "0 4px 10px rgba(0,0,0,0.2)"
                }}
            >
                ↑
            </button>
        </>
    );
};

export default MyProfile;